// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__GfAFg","active":"NavBar_active__dq9zA"};